import { render, staticRenderFns } from "./XueYaChart.vue?vue&type=template&id=2987e2d6&scoped=true"
import script from "./XueYaChart.vue?vue&type=script&lang=js"
export * from "./XueYaChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987e2d6",
  null
  
)

export default component.exports